
import { defineComponent } from "vue";

import ChronometerComp from "./ChronometerComp.vue";
import Button from "./ButtonComp.vue";

export default defineComponent({
  name: "TimerComp",
  emits: ["onTimerIsFinish"],
  data() {
    return {
      timeInSeconds: 0,
      chron: 0,
      chronIsRunnning: false,
    };
  },
  methods: {
    start() {
      this.chron = setInterval(() => {
        this.timeInSeconds++;
      }, 1000);
      this.chronIsRunnning = true;
    },
    finish() {
      this.$emit("onTimerIsFinish", this.timeInSeconds);
      clearInterval(this.chron);
      this.timeInSeconds = 0;
      this.chronIsRunnning = false;
    },
  },
  components: { ChronometerComp, Button },
});
